import { BaseState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { GuestList, GuestListResource } from '~/store/guest_lists/guest-lists.types'

export enum InviteStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Cancelled = 'CANCELLED',
  Removed = 'REMOVED'
}

export interface Invite {
  type: SohoModel.Invite
  id: string
  guestName: string
  status: InviteStatus,
  guestList: GuestList,
  inviterName: string
}

export interface InviteRelationships extends JsonApi.Relationships {
  guest_list: JsonApi.Relationship<GuestListResource>
}

export type InviteResource = JsonApi.ResourceObject<Invite, InviteRelationships>

export type InvitesState = BaseState<InviteResource>
